import React from 'react';
import { Link } from 'react-router-dom';

import { Image } from 'src/components/PageBuilder/components/Image/components';

import { getAdvancedSettings } from '../advancedSettings';

import type { ImageType } from './imageConfigAggregator';

type PageBuilderImageProps = ImageType;

/**
 * Return the PB Image Wrapper
 * @param props
 * @constructor
 */
export function PageBuilderImage(props: PageBuilderImageProps) {
    /**
     * Configure the styles requires for the Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderImageProps>(props);

    const figureStyles = {
        margin: advancedSettings.margin,
        marginBottom: advancedSettings.marginBottom,
        marginLeft: advancedSettings.marginLeft,
        marginRight: advancedSettings.marginRight,
        marginTop: advancedSettings.marginTop,
        padding: advancedSettings.padding,
        paddingBottom: advancedSettings.paddingBottom,
        paddingLeft: advancedSettings.paddingLeft,
        paddingRight: advancedSettings.paddingRight,
        paddingTop: advancedSettings.paddingTop,
        textAlign: advancedSettings.textAlign,
    };

    const pictureStyles = {
        borderColor: advancedSettings.borderColor,
        borderRadius: advancedSettings.borderRadius,
        borderStyle: advancedSettings.borderStyle,
        borderWidth: advancedSettings.borderWidth,
    };

    /**
     * Render the Image UI
     */
    if (props.linkType && props.link) {
        return (
            <Link
                to={props.link}
                target={props.openInNewTab ? '_blank' : '_self'}
                aria-label={props.altText || 'Image Link'}
            >
                <Image figureStyles={figureStyles} pictureStyles={pictureStyles} {...props} />
            </Link>
        );
    }

    return <Image figureStyles={figureStyles} pictureStyles={pictureStyles} {...props} />;
}
